import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import MarkerClusterer from '@googlemaps/markerclustererplus';

@Component({
  selector: 'app-common-table',
  templateUrl: './common-table.component.html',
  styleUrls: ['./common-table.component.scss']
})
export class CommonTableComponent implements OnInit {

  mapView = false;

   
    constructor(@Inject(MAT_DIALOG_DATA) private parentData: any, private dialog: MatDialogRef<CommonTableComponent>, private router: Router,) { }
  dataSource: any = [];
  displayedColumns: any = [];
  title = '';
  showMap = false;
  map;
  truckIcon = {
    url: 'assets/truck-icon.svg',
    scaledSize: new google.maps.Size(30, 30)
  };
  bounds;
  mapMarkers: any = [];
  markerCluster: MarkerClusterer;

  ngOnInit(): void {
    this.dataSource = this.parentData.dataSource;
    console.log("🚀 ~ file: common-table.component.ts:17 ~ CommonTableComponent ~ ngOnInit ~ this.dataSource", this.dataSource);
    this.displayedColumns = this.parentData.displayedColumns;
    this.title = this.parentData.title;
    this.mapView = this.parentData.mapView || false;
    console.log("🚀 ~ file: common-table.component.ts:32 ~ CommonTableComponent ~ ngOnInit ~ this.mapView", this.mapView);
    
  this.mapMarkers = [];
  }
  openCustomerMap(point) {
    if (point.length > 0) {
      const url = "https://maps.google.com/?q=" + point[1] + "," + point[0];
      window.open(url);
    }
  }
  initMap() {
    this.mapMarkers = [];
    // this.markerCluster.clearMarkers();

      this.map = new google.maps.Map(document.getElementById('mapId'), {
      center: { lat: 12.960691, lng: 77.580116 },
      zoom: 12,
      mapTypeControl: true,
      scaleControl: false,
      streetViewControl: false,
      zoomControl: true,
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.DROPDOWN_MENU
      }
    });
    google.maps.event.trigger(this.map, 'resize');
    this.loadMarkers();
  }
  loadMarkers() {
    this.mapMarkers = [];
    this.bounds = new google.maps.LatLngBounds();
    this.dataSource.forEach(e => {
      let content = '<div class="infoWindow" style="display: flex; flex-direction: column;width: 300px; font-family: Inter">' +
              '<div class="top" style=" display: flex;flex-direction: column;">';
            if (e.Vehicle) content += '<div class="info" style="display: flex;height: 25px;align-items: center;"> <div class="info-text" style="width: 140px; display:flex; justify-content: left; font-weight: bold;">Vehicle Number: </div> <div class="info-detail" style=" display:flex;justify-content: left">' + e.Vehicle + '</div> </div>';
            //  content = e.vehicleNumber ? 'Vehicle Number: ' + e.vehicleNumber : '';
            if (e.Carrier) {
              content += '<div class="info" style="display: flex;height: 25px;align-items: center;"> <div class="info-text" style="width: 140px; display:flex; justify-content: left; font-weight: bold;">Carrier: </div> <div class="info-detail" style="white-space: nowrap;  width: 150px; overflow: hidden; text-overflow: ellipsis;">' + e.Carrier + '</div> </div>';
            }
            if (e.Driver) {
              content += '<div class="info" style="display: flex;height: 25px;align-items: center;"> <div class="info-text" style="width: 140px; display:flex; justify-content: left; font-weight: bold;">Driver: </div> <div class="info-detail" style=" display:flex;justify-content: left">' + e.Driver + '</div> </div>';
            }
            if (e['Driver Mobile']) {
              content += '<div class="info" style="display: flex;height: 25px;align-items: center;"> <div class="info-text" style="width: 140px; display:flex; justify-content: left; font-weight: bold;">Driver Mobile: </div> <div class="info-detail" style=" display:flex;justify-content: left">' + e['Driver Mobile'] + '</div> </div>';
            }
            if (e['Preferred Location']) {
              content += '<div class="info" style="display: flex;height: 25px;align-items: center;"> <div class="info-text" style="width: 140px; display:flex; justify-content: left; font-weight: bold;">Preferred Location: </div> <div class="info-detail" style=" display:flex;justify-content: left">' + e['Preferred Location'] + '</div> </div>';
            }
            content += '</div>';
      this.placeMarker(e.location, content);
      const latLng = { lat: parseFloat(e.location.latitude), lng: parseFloat(e.location.longitude) };
      this.bounds.extend(latLng);
      this.map.fitBounds(this.bounds);
    });
    if (this.mapMarkers.length) {
      this.cluster();
    }
    
  }
  placeMarker(location, content) {
    const markerOpt: any = {
      position: { lat: parseFloat(location.latitude), lng: parseFloat(location.longitude) },
      map: this.map,
      icon: this.truckIcon,
    };
    const marker = new google.maps.Marker(markerOpt);

    if (content) {
      const infowindow = new google.maps.InfoWindow({
        content,
        ...(!content.includes('Duration') && {pixelOffset: new google.maps.Size(200, 150)}),
      });
      google.maps.event.addListener(marker, 'click', function () {
        infowindow.open(this.map, marker);
      });
      // google.maps.event.addListener(marker, 'mouseout', function () {
      //   infowindow.close(map, marker);
      // });
    }

    this.mapMarkers.push(marker);
    marker.setMap(this.map);
    
  }
  openShipments() {
    const data = `${this.parentData.shipmentType}-${this.parentData.shipmentIds}`;
    window.open(`shipmentsDashboard/${data}`, '_blank');
    this.dialog.close();
  }
  removeMarkers() {
    if (this.markerCluster) {
      this.markerCluster.clearMarkers();
      this.markerCluster.removeMarkers(this.mapMarkers);
    }

    this.mapMarkers.forEach(element => {
      element.setMap(null);
    });
    this.mapMarkers = [];
  }
  cluster() {
    this.markerCluster = new MarkerClusterer(this.map, this.mapMarkers, {
      maxZoom: 18,
      imagePath:
        'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
    });
  }

}
